import {FC, useMemo} from 'react'
import {
  SearchSelect,
  SearchSelectOption,
} from '../../../../../../../_metronic/helpers/components/SearchSelect'
import {InvoiceListSeasonOption} from '../../core/_models'
import {formatInvoiceCount} from '../../core/_formatters'
import {
  INVOICE_LIST_SEASON_ALL_KEY,
  isAllInvoiceSeasonValue,
  normalizeInvoiceSeasonValue,
  splitInvoiceSeasonValue,
} from '../../core/invoiceSeasonSelection'
import './InvoiceListToolbar.css'

type Props = {
  seasons?: InvoiceListSeasonOption[]
  value?: string
  loading?: boolean
  disabled?: boolean
  label?: string
  placeholder?: string
  onChange: (invoiceSeason: string) => void
}

const allOption: SearchSelectOption = {
  value: INVOICE_LIST_SEASON_ALL_KEY,
  label: 'همه فصل‌ها',
}

const InvoiceSeasonSelect: FC<Props> = ({
  seasons = [],
  value,
  loading = false,
  disabled = false,
  label = 'فصل صورتحساب',
  placeholder = 'انتخاب فصل‌ها',
  onChange,
}) => {
  const seasonOptions = useMemo<SearchSelectOption[]>(
    () =>
      seasons.map((season) => ({
        value: season.key,
        label: `${season.name} - ${formatInvoiceCount(season.count)} صورتحساب`,
      })),
    [seasons]
  )

  const options = useMemo(() => [allOption, ...seasonOptions], [seasonOptions])

  const selectedOptions = useMemo<SearchSelectOption[]>(() => {
    const normalized = normalizeInvoiceSeasonValue(value)
    if (isAllInvoiceSeasonValue(normalized)) {
      return [allOption]
    }

    const selectedKeys = splitInvoiceSeasonValue(normalized)
    return selectedKeys
      .map((key) => options.find((option) => option.value === key))
      .filter(Boolean) as SearchSelectOption[]
  }, [options, value])

  const setSelectedOptions = (nextValue: SearchSelectOption[] | SearchSelectOption | undefined) => {
    const selected = Array.isArray(nextValue) ? nextValue : nextValue ? [nextValue] : []
    if (!selected.length) {
      onChange(INVOICE_LIST_SEASON_ALL_KEY)
      return
    }

    const normalizedCurrentValue = normalizeInvoiceSeasonValue(value)
    const selectedWithoutAll = selected.filter(
      (option) => option.value !== INVOICE_LIST_SEASON_ALL_KEY
    )
    const hasAll = selectedWithoutAll.length !== selected.length
    if (hasAll) {
      if (isAllInvoiceSeasonValue(normalizedCurrentValue) && selectedWithoutAll.length) {
        onChange(normalizeInvoiceSeasonValue(selectedWithoutAll.map((option) => option.value).join(',')))
        return
      }

      onChange(INVOICE_LIST_SEASON_ALL_KEY)
      return
    }

    onChange(normalizeInvoiceSeasonValue(selected.map((option) => option.value).join(',')))
  }

  return (
    <div className='mp-invoice-season-select'>
      <SearchSelect
        section=''
        label={label}
        placeholder={loading ? 'در حال دریافت فصل‌ها...' : placeholder}
        stateValue={{
          value: selectedOptions as any,
          setValue: setSelectedOptions as any,
        }}
        items={options}
        isMulti
        isDisabled={disabled}
      />
    </div>
  )
}

export {InvoiceSeasonSelect}
